/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.15.0
 */

import styled from 'styled-components';

import { ImgStyled } from '../../../../components/common/Block/Img';
import { colors } from '../../../../theme';

export const OnboardingTooltipStyled = styled.div.attrs({
    'className': 'onboarding-tooltip',
    'data-name': 'onboarding-tooltip',
})`
    position: relative;
    width: 400px;
    padding: 32px 24px;
    background-color: ${colors.backgroundColorWhite};

    .onboarding-tooltip__cross {
        position: absolute;
        top: 12px;
        right: 12px;
    }

    .onboarding-tooltip__text {
        margin-bottom: 16px;
    }

    .onboarding-tooltip__control,
    .onboarding-tooltip__page {
        display: flex;
        align-items: center;
    }

    .onboarding-tooltip__link {
        flex-grow: 1;
    }

    .onboarding-tooltip__arrow {
        cursor: pointer;
        padding: 4px;
        margin: 0 16px;
        border-radius: 100%;
        border: 2px solid ${colors.borderColorSuccess};

        &.onboarding-tooltip__arrow_disabled {
            border-color: ${colors.borderColorLight};
        }

        ${ImgStyled} {
            min-width: 24px;
            min-height: 24px;
        }
    }
`;
